import { IApiError } from '@/models/apiError.model';
import { IChannelLLMTemplate } from '@/models/llmTemplate.model';

export const SLICE_NAME = 'llmChannelTemplate';

export interface LLMChannelTemplateState {
  template: IChannelLLMTemplate | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: LLMChannelTemplateState = {
  template: null,
  isLoading: false,
  error: null,
};
